import React, { useState } from "react";
import Nav from "react-bootstrap/Nav";
import styled from "styled-components";

//*componente
//Install
//npm install --save styled-components

//*interfaces
interface PropsMenuV {
  menu: any;
}

export default function ParteMenu(props: PropsMenuV) {
  let menu = props.menu;

  const [isOpened, setIsOpened] = useState(false);
  const [step, setStep] = useState("1");

  function toggle(stepId: any, activo: any, subm: any) {
    //console.log("stepId..actual...", stepId);
    //console.log("step....", step);

    //let stepAnt = setStep;
    if (subm !== null) {
      if (step !== stepId) {
        let stepAnt = Number(step) - 1;

        if (stepAnt >= 0) menu[stepAnt].activo = "f";

        if (menu[stepId - 1].activo === "t") {
          menu[stepId - 1].activo = "f";
          setIsOpened(false);
        } else {
          menu[stepId - 1].activo = "t";
          setIsOpened(true);
        }

        setStep(stepId);
      } else {
        // console.log("es igual", step, step !== stepId);
        if (menu[stepId - 1].activo === "t") {
          menu[stepId - 1].activo = "f";
          setIsOpened(false);
        } else {
          menu[stepId - 1].activo = "t";
          setIsOpened(true);
        }
        setStep("0");
      }
    }
    //console.log(menu, "pasoMenu.....");
  }

  return (
    <div>
      <Nav variant="pills" className="flex-column navM  " id="menu">
        <Nav.Item>
          <div id="navitemSolicitudes">Solicitudes</div>
        </Nav.Item>
        {menu.map((item: any) => (
          <Nav.Item key={item.id} id={"idnav" + item.id}>
            <Navnav id="navnav">
              <Nav.Link
                eventKey={item.id}
                disabled={item.isDisabled}
                onClick={() => toggle(item.id, item.activo, item.subMenu)}
              >
                {item.desc}
                {item.subMenu !== null ? (
                  <div>
                    <nav>
                      <ul>
                        {" "}
                        <li>
                          <div>
                            {item.subMenu.map((itemS: any) => (
                              <>
                                <li>
                                  {item.activo !== "f" ? (
                                    <>
                                      {isOpened && (
                                        <>
                                          <a href="#">{itemS.desc}</a>
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </li>
                              </>
                            ))}
                          </div>
                        </li>
                      </ul>
                    </nav>
                  </div>
                ) : (
                  <span></span>
                )}
              </Nav.Link>
            </Navnav>
          </Nav.Item>
        ))}
      </Nav>
    </div>
  );
}

const Navnav = styled.div`
width: "258px",
textDecoration: "underline",
`;
